import { render, staticRenderFns } from "./TicketArquivos.vue?vue&type=template&id=21876696&scoped=true&"
import script from "./TicketArquivos.vue?vue&type=script&lang=js&"
export * from "./TicketArquivos.vue?vue&type=script&lang=js&"
import style0 from "./TicketArquivos.vue?vue&type=style&index=0&id=21876696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21876696",
  null
  
)

export default component.exports